module.exports = __webpack_public_path__ + "static/media/mpha-logo.1e3f30a0.svg";